
export default {
	name: "FeatureCard",
	props: {
		icon: {
			type: String,
			default: "",
		},
		title: {
			type: String,
			required: true,
		},
		description: {
			type: String,
			required: true,
		},
		white: {
			type: Boolean,
			default: false,
		},
	},
};
